import { useNavigate } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";

const Logout = () => {
  const navigate = useNavigate();
  const adminID = localStorage.getItem("adminID");

  if (!adminID) return null;

  return (
    <button
      style={logout}
      onClick={() => {
        localStorage.clear();
        navigate("/");
      }}
    >
      <FaSignOutAlt /> Logout
    </button>
  );
};

const logout = {
  background: "transparent",
  border: "1px solid #fff",
  color: "#fff",
  padding: "12px 16px",
  borderRadius: "8px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "18px",
  fontWeight: "700",
  lineHeight: 1.2
};

export default Logout;





